import { render, staticRenderFns } from "./change-review.vue?vue&type=template&id=6290c408&scoped=true"
import script from "./change-review.vue?vue&type=script&lang=js"
export * from "./change-review.vue?vue&type=script&lang=js"
import style0 from "./change-review.vue?vue&type=style&index=0&id=6290c408&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6290c408",
  null
  
)

export default component.exports